import {
  Draggable,
  Droppable,
  DragDropContext,
} from '@hello-pangea/dnd';

import {
  Icon,
  Switch,
} from 'web-components';

import {
  Flex,
  SVG,
} from 'web-styled';

import * as S from './styled';

type Props = {
  properties: any[],
  onDragEnd: { (result: any): void },
  onChangeVisible: { (peroperty: any): void },
};

const PersonalProperties = ({
  properties,
  onDragEnd,
  onChangeVisible,
}: Props) => (
  <Flex column scrollY fillSpace>
    <S.Item>
      <Flex
        align="center"
        flex="0 0 25%"
      >
        <S.HeaderName>Metric Name</S.HeaderName>
      </Flex>
      <Flex
        align="center"
        flex="0 0 16.66666667%"
      >
        <S.HeaderName>Visibility</S.HeaderName>
      </Flex>
    </S.Item>
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {droppableProvided => (
          <Flex
            ref={droppableProvided.innerRef}
            width="100%"
            column
          >
            {properties.map((property, index) => (
              <Draggable
                key={property.id}
                draggableId={String(property.id)}
                index={index}
              >
                {provided => (
                  <S.Item
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                  >
                    <Flex
                      align="center"
                      flex="0 0 25%"
                    >
                      <S.Sort
                        {...provided.dragHandleProps}
                      >
                        <SVG.MoveVertical size={14} />
                      </S.Sort>
                      <span>
                        {property.name}
                      </span>
                    </Flex>
                    <Flex
                      align="center"
                      flex="0 0 16.66666667%"
                    >
                      <Switch
                        id={property.id}
                        checked={property.is_visible}
                        onChange={() => onChangeVisible(property)}
                      />
                    </Flex>
                  </S.Item>
                )}
              </Draggable>
            ))}
            {droppableProvided.placeholder}
          </Flex>
        )}
      </Droppable>
    </DragDropContext>
  </Flex>
);

export default PersonalProperties;
